import React from "react";
import PrimeButton from "../components/PrimeButton";

export default function NotFound() {
  return (
    <>
      <main className=" h-screen flex items-center justify-center flex-col gap-5 bg-black">
        <img src={require("../assets/h2a 3.png")} className="w-40" alt="Not Found Image"/>
        <h4 className="text-4xl text-center text-primary-color font-semibold">NOT FOUND PAGE</h4>
        <PrimeButton path="/" text="Back To Home →" size="text-2xl" />
      </main>
    </>
  );
}
